import { defineRoute } from '@epihub/core/src/routes';

export const homeChatRoute = defineRoute('homeChat', {
  path: '/',
  parsePath: {},
  hashes: {},
  parseSearch: {},
});

export const bookCalendarRoute = defineRoute('bookCalendar', {
  path: '/calendar',
  parsePath: {},
  hashes: {},
  parseSearch: {},
});

export const privacyRoute = defineRoute('privacy', {
  path: '/privacy',
  parsePath: {},
  hashes: {},
  parseSearch: {},
});

export const cookieRoute = defineRoute('cookie', {
  path: '/cookies',
  parsePath: {},
  hashes: {},
  parseSearch: {},
});

export const downloadCVRoute = defineRoute('cv', {
  path: '/cv',
  parsePath: {},
  hashes: {},
  parseSearch: {},
});
